import { IIntegerPrecisionService } from '@core/interfaces/integer-precision-service.interface';
import { MenuItem, WorkDay } from '@core/models';
import { calculateCartItem } from '../util/cart-item-calculation.util';
import { CartCalculationStrategy } from '../interfaces/cart-calculation-strategy.interface';
import { CartItemCalculation } from '../interfaces/cart-item-calculation.interface';

export class RegularCartCalculationStrategy implements CartCalculationStrategy {
	calculateItem(
		item: MenuItem,
		couponDiscount: bigint,
		precisionService: IIntegerPrecisionService,
		workDay: WorkDay
	): CartItemCalculation {
		return calculateCartItem(item, 'price', couponDiscount, precisionService, workDay);
	}
}
